// @ts-nocheck
import { ReactComponent as FilterIcon } from '../../../assets/Icons/lucideIcons/funnel.svg';
import { Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import PropTypes from 'prop-types';

const ColumnHeaderWithFilter = ({ children, onFilterClick, columnLabel }) => {
  const handleFilterIconClick = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      onFilterClick?.({
        columnLabel,
      });
    },
    [onFilterClick, columnLabel]
  );
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',

        '&:hover .FilterIcon': {
          visibility: 'visible',
        },
      }}
    >
      {children}

      <IconButton
        className="FilterIcon"
        size="small"
        aria-label="open-column-filter"
        onClick={handleFilterIconClick}
        sx={{
          visibility: 'hidden',
        }}
      >
        <FilterIcon style={{ width: '16px', height: '16px' }} />
      </IconButton>
    </Box>
  );
};

ColumnHeaderWithFilter.propTypes = {
  children: PropTypes.node.isRequired,
  onFilterClick: PropTypes.func,
  columnLabel: PropTypes.string.isRequired,
};

export default ColumnHeaderWithFilter;
